import React from 'react'
import './OperationBtn.less'

const RightBtn = ({ added, onClick }) => {
  return <i className={`icon-operation ${added ? 'added' : ''}`} onClick={onClick}/>
}

export default RightBtn








// WEBPACK FOOTER //
// ./src/pages/MajorWishListNew/OperationBtn.js